<script setup lang="ts">
import type { IgMediaItem } from '~~/src/core/types';

const props = defineProps<{
  post: IgMediaItem;
}>();

const isVideo = computed(() => props.post.media_type === 'VIDEO');
</script>

<template>
  <AppLink
    type="custom"
    :to="post.permalink"
    :opts="{}"
    class="relative block aspect-4/5 w-full overflow-hidden rounded-xl"
  >
    <video
      v-if="isVideo"
      :src="post?.media_url"
      :alt="post?.alt_text"
      autoplay
      muted
      loop
      playsinline
      :controls="false"
      class="h-full w-full object-cover"
    />
    <img
      v-else
      :src="post?.media_url"
      :alt="post?.alt_text"
      class="h-full w-full object-cover"
    />
  </AppLink>
</template>
